import { render, staticRenderFns } from "./DIconPDF.vue?vue&type=template&id=2530ba9c&scoped=true&"
import script from "./DIconPDF.vue?vue&type=script&lang=js&"
export * from "./DIconPDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530ba9c",
  null
  
)

export default component.exports